<template lang="html">
  <PrimeDropdown :disabled="disabled"
                 optionLabel="normalizedName"
                 :filter="filterable"
                 :filterPlaceholder="$t('Поиск...')"
                 :emptyFilterMessage="$t('Ничего не найдено')"
                 optionValue="id"
                 dataKey="id"
                 :options="normalizedAddresses"
                 :placeholder="$t('Выберите адрес')"
                 class="crypto-address-dropdown"
                 v-model="val">
    <template #value="slotProps">
      <template v-if="selectedAddress">
        <div class="address-option-wrap selected-address">
          <div class="address-option ">
            <div class="content__number">
              <template v-if="selectedAddress.is_generating">{{
                  $t('Адрес генерируется...')
                }}
              </template>
              <template v-else>{{ selectedAddress.censoredAddress }}<strong
                class="crypto-address-system-badge" v-if="selectedAddress.system"
                :class="cryptoAddressSystemBadgeClass(selectedAddress)">{{
                  selectedAddress.system
                }}</strong>
              </template>
            </div>
            <div class="content__amount">{{ selectedAddress.publicCurrency }}</div>
            <div class="content__name"
                 v-if=" selectedAddress.name &&  selectedAddress.name?.length > 0">
              &laquo;{{ selectedAddress.name }}&raquo;
            </div>
          </div>
          <template v-if="selectedAddress.autoConvert && selectedAddress.autoConvertAccountNumber">
            <div class="address-option--autoconvert">
              <i18n path="autoconvertHint" class="address-option--autoconvert--text" tag="div">
                <template #account>
                  <span class="address-option--autoconvert--account">{{
                      selectedAddress.autoConvertAccountNumber
                    }}</span>
                  <template v-if="selectedAddress.isCardsProAutoconvertAccountNumber">
                    <DropdownCryptoAddressCardsproBadge/>
                  </template>
                </template>
              </i18n>
            </div>
          </template>
        </div>
      </template>
      <template v-else>{{ slotProps.placeholder }}</template>
    </template>

    <template #option="{option}">
      <div class="address-option-wrap">
        <div class="address-option">
          <div class="content__number">
            <template v-if="option.is_generating">{{ $t('Адрес генерируется...') }}</template>
            <template v-else>{{ option.censoredAddress }}<strong
              class="crypto-address-system-badge" v-if="option.system"
              :class="cryptoAddressSystemBadgeClass(option)">{{ option.system }}</strong>
            </template>

          </div>
          <div class="content__amount">{{ option.publicCurrency }}</div>
          <div class="content__name" v-if="option.name && option.name?.length > 0">
            &laquo;{{ option.name }}&raquo;
          </div>
        </div>
        <template v-if="option.autoConvert && option.autoConvertAccountNumber">
          <div class="address-option--autoconvert">
            <i18n path="autoconvertHint" class="address-option--autoconvert--text" tag="div">
              <template #account>
              <span class="address-option--autoconvert--account">{{
                  option.autoConvertAccountNumber
                }}</span>
                <template v-if="option.isCardsProAutoconvertAccountNumber">
                  <DropdownCryptoAddressCardsproBadge />
                </template>
              </template>
            </i18n>
          </div>
        </template>
      </div>
    </template>
  </PrimeDropdown>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
import {formatUnixDateFilter} from '@/models/filters/datetime';
import {MoneyFormatFilter} from '@/models/filters/money';
import {CryptoAddress} from '@/models/finance/crypto';
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";
import DropdownCryptoAddressCardsproBadge
  from "@/components/forms/dropdown/DropdownCryptoAddressCardsproBadge.vue";


@Component({
  name: 'dropdown-crypto-addresses',
  components: {
    DropdownCryptoAddressCardsproBadge,
    PrimeDropdown,
  },
  filters: {
    tsFormat: formatUnixDateFilter,
    moneyFormat: MoneyFormatFilter,
  },
})
export default class DropdownCryptoAddresses extends Vue {
  @Prop({required: true})
  addresses!: CryptoAddress[]

  @Prop({required: true})
  value!: CryptoAddress

  @Prop({default: false})
  disabled!: boolean


  get normalizedAddresses() {
    return (this.addresses || [])
      // .sort((a: CryptoAddress, b: CryptoAddress) => {
      //   if (a.is_generating) return -1;
      //   if (b.is_generating) return 1;
      //   return 0;
      // })
      .sort((a: CryptoAddress, b: CryptoAddress) => {
        return a.name?.localeCompare(b.name);
      })

      .sort((a: CryptoAddress, b: CryptoAddress) => {
        const aA = a.autoConvert && a.autoConvertAccountNumber;
        const bA = b.autoConvert && b.autoConvertAccountNumber;
        if (aA && !bA) return -1;
        if (!aA && bA) return 1;
        return 0;
      })
      .sort((a: CryptoAddress, b: CryptoAddress) => {
        if (a.isCardsProAutoconvertAccountNumber) return -1;
        if (b.isCardsProAutoconvertAccountNumber) return 1;
        return 0;
      })
  }

  get val() {
    return this.value?.id;
  }

  get filterable() {
    return this.normalizedAddresses && this.normalizedAddresses.length > 9;
  }

  set val(value) {
    const address = value ? this.addresses.find((a) => String(a.id) == String(value)) : null;
    this.$emit('input', address);
  }


  @Watch('addresses')
  onAddressesChanged() {
    if (this.value?.id && this.addresses.find((a) => a.id == this.value.id)) {
      return;
    }
    this.$emit('input', null);
  }

  get selectedAddress() {
    return this.value;
  }

  cryptoAddressSystemBadgeClass(address: CryptoAddress) {
    return {
      'crypto-address-system-badge': true,
      [`crypto-address-system-badge__${address.system.toLowerCase()}`]: !!address.system,
    };
  }
}
</script>

<style scoped lang="less">
.crypto-address-dropdown {
  ::v-deep {
    height: auto;

    .address-option {
      padding: 2px 0;
    }

    .selected-address {
      .address-option {
        padding: 5px 0;
      }
    }

    .address-option-wrap {
      display: flex;
      flex-direction: column;
    }

    .address-option--autoconvert {
      //border-top: 3px solid #eea236;
      .address-option--autoconvert--text {
        background-color: #fcf8e3;
        color: #555 !important;
        padding: 1px 5px;
        border-radius: 5px;
        display: inline-block;
      }

      font-size: 85%;

      .address-option--autoconvert--account {
        font-weight: bold;
      }
    }
  }
}

::v-deep {

  .address-option-wrap {
    width: 100%;
  }

  .address-option {
    display: grid;
    grid-template-columns: auto max-content;
    grid-gap: 3px 8px;

    .content__name {
      grid-column-start: 1;
      grid-column-end: 3;
      font-size: 85%;
    }

    .content__number, .content__amount {
      font-weight: bolder;
    }

    .content__amount {
      text-align: right;
    }

    .crypto-address-system-badge {
      display: inline;
      margin: 0 5px;
      border-radius: 5px;
      padding: 2px 5px;
      color: #fff;

      &__erc20 {
        background: #8392DB;
      }

      &__trc20 {
        background: #E97D75;
      }
    }
  }
}

/*
.form-control {
  height: 48px !important;

  &[disabled] {
    opacity: 1 !important;

    &.btn.btn-default {
      background-color: #eeeeee;
    }
  }

  &.btn.btn-default {
    background-color: rgb(242, 243, 248);
  }
}
*/

/*.form-control-dropdown::v-deep {
  display: block;
  height: 48px;

  .dropdown-accounts__li__content {
    display: grid;
    grid-template-columns: auto max-content;
    grid-gap: 3px 8px;

    .content__name {
      grid-column-start: 1;
      grid-column-end: 3;
      font-size: 85%;
    }

    .content__number, .content__amount {
      font-weight: bolder;
    }

    .content__amount {
      text-align: right;
    }
  }

  .dropdown-menu {
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
  }

  li.dropdown-accounts-list-item {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .dropdown-selected-body {
    overflow: hidden;
    white-space: normal;
    margin-right: 20px;
    display: block;
  }

  .dropdown-toggle {
    text-align: left;
    //
    //&:after {
    //  content: "";
    //  display: block;
    //  width: 0;
    //  height: 0;
    //  border-style: solid;
    //  border-width: 5px 5px 0 5px;
    //  border-color: #333 transparent transparent transparent;
    //  position: absolute;
    //  right: 15px;
    //  top: 50%;
    //  -webkit-transform: translateY(-50%);
    //  transform: translateY(-50%);
    //}

    font-weight: 300;
    font-family: 'Proxima Nova Lt', sans-serif;
    position: relative;
    -webkit-box-shadow: inset 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
    box-shadow: inset 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
    border: none;
    line-height: 30px;
    padding: 1px 15px 0;
    height: 36px;

    &:focus {
      border-color: #66afe9;
      outline: 0;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
    }
  }

  .crypto-address-system-badge {
    display: inline;
    margin: 0 5px;
    border-radius: 5px;
    padding: 2px 5px;
    color: #fff;

    &__erc20 {
      background: #8392DB;
    }

    &__trc20 {
      background: #E97D75;
    }
  }

  .dropdown-menu {
    padding: 10px 5px;

    li {
      padding: 0;
      margin: 0;

      a {
        padding: 5px 15px;

        &:hover {

        }
      }

      &:hover, &.selected:hover {
        //background: #80bd1c;
        //color: #fff;

        a {
          font-weight: bolder;
          background: #80bd1c;
          color: #fff;
        }
      }

      &.selected {
        //background: #80bd1c;
        //color: #fff;

        a {
          font-weight: bolder;
          background: #dedede;
          color: #000000;
        }
      }
    }
  }
}*/
</style>

<i18n>
{
  "ru": {
    "autoconvertHint": "Автоконверт на счет {account}"
  },
  "en": {
    "autoconvertHint": "Autoconvert to account {account}",
    "Поиск...": "Search...",
    "Ничего не найдено": "Nothing found",
    "Выберите": "Please select",
    "Выберите счет": "Please select account",
    "Выберите адрес": "Please select address",
    "Адрес генерируется...": "Address is generating..."
  }
}
</i18n>
